import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'porcent'
})
export class PorcentagemPipe implements PipeTransform {
    transform(value: number): any {
            if (value) {
                return value + '%'
            }
            return value;
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/porcentagem.pipe.ts